import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { GiRelationshipBounds } from "react-icons/gi";

const RelationshipWithMutualCompany = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  return (
    <div className={styles.LealtadinformacionPolitica} id="relacion">
      <div className={styles.LealtadsectionTitle2}>
        <h2 className={styles.LealtadsectionTitleH2}>Relación con la Mutual</h2>
        <IconAnimation />
      </div>
      {!company || !company.RelationshipWithMutualCompany ? (
        <NotReportViewData
          title="Relación con la mutual"
          Icon={GiRelationshipBounds}
        />
      ) : (
        <>
          <label className={styles.LealtadinputLabel}>
            Relación:
            <select
              className={styles.LealtadinputField}
              name="relation"
              value={company.RelationshipWithMutualCompany.relation}
              disabled={!isEditing}
            >
              <option value="Proveedor">Proveedor</option>
              <option value="Fondista">Fondista</option>
            </select>
          </label>
          <label className={styles.LealtadinputLabel}>
            Canal:
            <input
              className={styles.LealtadinputField}
              name="canal"
              value={company.RelationshipWithMutualCompany.canal}
              disabled={!isEditing}
            />
          </label>
          <label className={styles.LealtadinputLabel}>
            Tipo de crédito:
            <select
              className={styles.LealtadinputField}
              name="typeOfCredit"
              value={company.RelationshipWithMutualCompany.typeOfCredit}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="Servicio">Servicio</option>
              <option value="Inversión">Inversión</option>
            </select>
          </label>
        </>
      )}
    </div>
  );
};

export default RelationshipWithMutualCompany;
